"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _reactReduxI18n = require("react-redux-i18n");

var _Icon = _interopRequireDefault(require("../components/Icon"));

var _jsxRuntime = require("react/jsx-runtime");

function InformationModal(props) {
  var handleSubmit = function handleSubmit() {
    props.onClose();
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactModal.default, {
    defaultStyles: {
      overlay: {
        backgroundColor: 'rgba(255,255,255,0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1001
      },
      content: {
        backgroundColor: '#fff',
        borderRadius: 4,
        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 0px 32px 0px',
        minWidth: 300,
        outline: 0,
        padding: 20,
        position: 'relative'
      }
    },
    isOpen: props.isOpen,
    onRequestClose: props.onClose,
    ariaHideApp: false,
    shouldCloseOnOverlayClick: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        textAlign: 'center'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          "data-id": "content",
          className: "py-4",
          children: props.children
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "actions col-12 inline-container flex-end",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            className: "large primary inline-container",
            id: "submit",
            type: "submit",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
              value: "action.confirm"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
              icon: "check"
            })]
          })
        })]
      })
    })
  });
}

InformationModal.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  isOpen: _propTypes.default.bool.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};
var _default = InformationModal;
exports.default = _default;
//# sourceMappingURL=InformationModal.js.map